import { useEffect, useState } from 'react';
import api from './api';

export const defaultSiteSettings = {
  companyName: 'ORVIX Solutions',
  email: 'info@orvix.com',
  phone: '+966 50 000 0000',
  address: 'الرياض، المملكة العربية السعودية',
  logo: '',
  workingDays: 'الأحد - الخميس',
  workingHours: '9:00 ص - 6:00 م'
};

export default function useSiteSettings() {
  const [settings, setSettings] = useState(defaultSiteSettings);

  useEffect(() => {
    let active = true;
    api.get('/settings')
      .then(({ data }) => {
        if (active) setSettings({ ...defaultSiteSettings, ...data });
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return settings;
}
